import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'commodityDescription'
})
export class CommodityDescriptionPipe implements PipeTransform {

  transform(description: string): string {    
    return description.toLowerCase()
    .split(' ')
    .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
    .join(' ');
  }
}
